export function scrollToReveal() {
    return {
        showProductHeader: false,
        lastPos: window.scrollY + 0,
        scroll() {
            this.showProductHeader = window.scrollY > this.$refs.productHeaderTrigger.offsetTop;
            this.lastPos = window.scrollY;
        }
    };
}